var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":_vm.Core.Definition.getDefinition('Message'),"hide-footer":true},model:{value:(_vm.dataShow),callback:function ($$v) {_vm.dataShow=$$v},expression:"dataShow"}},[_c('DynamicForm',{ref:"dynamicForm",attrs:{"ignoreRouteParamId":_vm.ignoreRouteParamId,"options":{
                    submit: {
                        text: 'Envoyer',
                        variant: 'success'
                    },
                    reset: {
                        text: 'Réinitialiser',
                        variant: 'light'
                    },
                    trash: {
                        text: 'Supprimer',
                        variant: 'danger'
                    }
            },"getRoot":_vm.options.root.get,"saveRoot":_vm.options.root.save,"trashRoot":_vm.options.root.trash,"formStructure":_vm.dataFormStructures.event},on:{"onInit":_vm.onInit,"onSave":_vm.onSave,"onTrashClick":_vm.onTrashClick,"onRequestSuccess":_vm.onRequestSuccess},model:{value:(_vm.dataId),callback:function ($$v) {_vm.dataId=$$v},expression:"dataId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }